// Payment System v3.0 (WS2) — payoff run React Query hook. The payoff retires
// the loan (state → retired_paid_in_full, balance → 0), so it invalidates the
// loan summary + health (badges / attention feed) and the servicing ledger.
// Transitions PR-3: the run also completes a Scheduled payoff-family
// transition, so the transitions scope (list/detail/console) refreshes too.

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { payoffApi, type PayoffRunRequest } from "@/api/portfolioAdmin/payoff";
import { servicingKeys } from "./useServicing";
import { loanTransitionsKeys } from "./loanTransitionsKeys";
import { invalidateLoanSummaryAndHealth } from "./invalidation";

export function usePayoff(loanId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: PayoffRunRequest) => payoffApi.run(loanId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: servicingKeys.ledger(loanId) });
      void qc.invalidateQueries({ queryKey: loanTransitionsKeys.all });
      void invalidateLoanSummaryAndHealth(qc, loanId);
    },
  });
}
